<template>
    <p class="folder-name" v-if='show_folder_name'>{{context_folder.name}}</p>

    <ActionButton v-show="!context_folder.main"
        @click='onFoldersEdit()'
        text='folders.actions.edit'
        icon='fas fa-edit'
        class='clear'
        :gtm="{
          module : props.module,
          feature: 'folders_edit_modal',
          block  : props.block,
          action : 'open'
        }"
    />
    <ActionButton v-show="!context_folder.main"
        @click="onFoldersMove()"
        text='folders.actions.move'
        icon='fas fa-folder-open'
        class='clear'
        :gtm="{
          module : props.module,
          feature: 'folders_move_modal',
          block  : props.block,
          action : 'open'
        }"
    />

    <ActionButton v-show="!context_folder.main"
        @click='onSubFoldersAdd()'
        text='folders.actions.add_subfolder'
        icon='fas fa-folder-plus'
        class='clear'
        :gtm="{
          module : props.module,
          feature: 'folders_create_subfolder_modal',
          block  : props.block,
          action : 'open'
        }"
    />

    <hr v-show="!context_folder.main">

    <ActionButton v-show="!disable_empty[context_folder.id] && (total_messages > 0 && !context_folder.main || total_messages === null)"
        @click="onFoldersEmpty()"
        text='folders.actions.empty'
        icon='far fa-folder empty-folder'
        class='clear'
        :gtm="{
          module : props.module,
          feature: 'folders_empty_modal',
          block  : props.block,
          action : 'open'
        }"
    />

    <ActionButton v-show="!context_folder.main"
        @click="onFoldersDelete()"
        text='folders.actions.delete'
        icon='fas fa-trash-alt'
        class='clear'
        :gtm="{
          module : props.module,
          feature: 'folders_delete_modal',
          block  : props.block,
          action : 'open'
        }"
    />

    <hr v-show="!context_folder.main">

    <ActionButton
        @click="onFolderCreateFilter"
        text='folders.actions.add_filter'
        icon='fas fa-filter'
        class='clear'
        :gtm="{
          module : props.module,
          feature: 'filters_form',
          block  : props.block,
          action : 'open'
        }"
    />
</template>

<script setup>
  import {defineProps}     from 'vue';
  import ActionButton      from '@/vue/Elements/Buttons/ActionButton.vue';
  import FoldersController from '@/js/Mailboxes/FoldersController';
  import StateConsumer     from '@/js/Shared/State/StateConsumer';
  import router            from '@/vue/router';
  import SAPOMailConfig    from '@/SAPOMailConfig';

  const props = defineProps({
    webmail_view : {
      required: true,
    },

    context_folder : {
      required : true,
    },

    state_initiator : {
      required: true,
    },

    show_folder_name : {
      default: true,
    },

    total_messages: {
      default: null,
    },

    module: {
      default: 'folders',
    },

    block: {
      default: null,
    }
  })

  const folders_controller = FoldersController;
  const disable_empty      = SAPOMailConfig.client.folders.disable_empty;

  const onSubFoldersAdd = () => {
    folders_controller.collection_state.setInitiator(props.state_initiator);
    props.webmail_view.openFoldersCreate(props.context_folder);
  }

  const onFoldersEdit = () => {
    folders_controller.collection_state.setInitiator(props.state_initiator);
    props.webmail_view.openFoldersEdit(props.context_folder);
  }

  const onFoldersDelete = () => {
    folders_controller.collection_state.setInitiator(props.state_initiator);
    props.webmail_view.openFoldersDelete(props.context_folder);
  }

  const onFoldersEmpty = () => {
    folders_controller.collection_state.setInitiator(props.state_initiator);
    props.webmail_view.openFoldersEmpty(props.context_folder);
  }

  const onFoldersMove = () => {
    folders_controller.collection_state.setInitiator(props.state_initiator);
    props.webmail_view.openFoldersMove(props.context_folder);
  }

  const onFolderCreateFilter = () => {
    StateConsumer.set('filters_folder_select', props.context_folder);
    router.push('/settings/filters/add')
  }
</script>
